module.exports = __webpack_public_path__ + "img/lang-28.20c4309f.jpg";